import { makeStyles } from '@material-ui/core/styles';

export const useAppInputStyles = makeStyles(() => ({
  input: {
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderRadius: 5,
    },
    '& .MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#f1f1f1',
    },
    width: '100%',
  },
  helperText: {
    textAlign: 'right',
  },
  errorText: {
    textAlign: 'right',
    color: 'red',
  },
  image: {
    height: 20,
    width: 20,
  },
  container: {
    display: (props) => (props.hidden ? 'none' : ''),
  },
}));
